// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e8yW3","toggle":"styles_toggle__3qdzc","preview":"styles_preview__37Zl0"};